import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { PostDetail } from '../modal';

export default function reducer(state: PostDetail = new PostDetail(),
  action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.POST_DETAIL_LIST_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.POST_DETAIL_LIST_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.POST_DETAIL_LIST_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
